import React, {useEffect, useState} from 'react';
import {Text, TouchableWithoutFeedback, View} from 'react-native';
import {useSelector} from 'react-redux';
import {PulseIndicator} from "react-native-indicators";
import {getConfig, getConnectionStatus} from "../reducers/configSlice";
import moment from "moment";
import Animated, {useAnimatedStyle, useSharedValue, withRepeat, withTiming} from "react-native-reanimated";
import {reconnectSocket} from "../services/socket/socket";
import {FONT_FAMILY, FONT_FAMILY_BOLD, FONT_FAMILY_LIGHT} from "../constants/styleConstants";
import {actuatedNormalize, setContrast, setContrastDate} from "../services/helpers/stylingHelpers";
import {reconnectSoketi} from "../services/soketi";
import {STORAGE} from "../services/storage";

const LiveClock = ({style}) => {
    let interval
    const connectionStatus = useSelector(getConnectionStatus)
    const config = useSelector(getConfig)

    const getHours = () => {
        return moment().tz(config.timezone).format(config.time_format === "ampm" ? 'h' : 'HH')
    }

    const getMinutes = () => {
        return moment().tz(config.timezone).format('mm')
    }

    const getAmpm = () => {
        return config.time_format === "ampm" ? moment().tz(config.timezone).format('A') : null
    }

    const [hours, setHours] = useState(getHours())
    const [minutes, setMinutes] = useState(getMinutes())
    const [ampm, setAmpm] = useState(getAmpm())
    const [textColor, setTextColor] = useState('#FFF')
    const [ampmColor, setAmpmColor] = useState('#999999')
    const showSeparator = useSharedValue(1)

    useEffect( () => {
        showSeparator.value = 1
        showSeparator.value = withRepeat(withTiming(0, {duration: 750}), -1, true);
    }, [])

    useEffect(() => {
        showSeparator.value = 1
        showSeparator.value = withRepeat(withTiming(0, {duration: 750}), -1, true);

        setTextColor(setContrast(Color(config.background_color).object()))
        setAmpmColor(setContrastDate(Color(config.background_color).object()))

        if (config) {
            clearInterval(interval)

            interval = setInterval(() => {
                setHours(getHours())
                setMinutes(getMinutes())
                setAmpm(getAmpm())
            }, 5000)
        }

        return () => clearInterval(interval);
    }, [config])

    const animStyle = useAnimatedStyle( () => {
        return {
            opacity: showSeparator.value
        }
    })

    const reconnectDevice = async () => {
        if (!connectionStatus) {
            const soketiUrl = await STORAGE.get("soketiUrl");
            if (soketiUrl) {
                await reconnectSoketi();
            } else {
                await reconnectSocket()
            }
        }
    }

    return (
        <View>
            {
                config && config.timezone &&
                    <TouchableWithoutFeedback hitSlop={{top: 10, bottom: 10, left: 20, right: 20}} onPress={ async () => await reconnectDevice()}>
                        <View style={[style]}>
                            <View style={{flexDirection: 'row', justifyContent: 'flex-end'}}>
                                <Text style={[{ fontSize: actuatedNormalize(23), fontFamily: FONT_FAMILY_LIGHT, color: textColor }]}>
                                    {hours}
                                </Text>
                                <Animated.Text style={[{ fontSize: actuatedNormalize(23), fontFamily: FONT_FAMILY_LIGHT, color: textColor }, animStyle]}>:</Animated.Text>
                                <Text style={[{ fontSize: actuatedNormalize(23), fontFamily: FONT_FAMILY_LIGHT, color: textColor }]}>
                                    {minutes}
                                </Text>
                                {
                                    ampm &&
                                    <Text style={[{ fontSize: actuatedNormalize(23), fontFamily:FONT_FAMILY_BOLD, color: ampmColor }]}>
                                        {' ' + ampm}
                                    </Text>
                                }
                            </View>
                            {
                                connectionStatus ?
                                    <View style={{marginTop: '2%'}}>
                                        <Text style={{fontSize: actuatedNormalize(8), textAlign: 'right', color: '#82BF68', fontFamily: FONT_FAMILY }}>
                                            {translate("Connected").toUpperCase()}
                                        </Text>
                                    </View> :
                                    <View style={{marginTop: '2%', flexDirection: 'row', alignItems: 'center'}}>
                                        <Text style={{fontSize: actuatedNormalize(8),textAlign: 'right', color: '#E83948', fontFamily: FONT_FAMILY, marginRight: actuatedNormalize(8)}}>
                                            {translate("Reconnecting").toUpperCase()}
                                        </Text>
                                        <PulseIndicator color='#E83948' size={actuatedNormalize(12)}/>
                                    </View>
                            }
                        </View>
                    </TouchableWithoutFeedback>
            }
        </View>
    )
}

export default LiveClock;
